import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { ValidatedResult } from '../../Models/Models/ValidatedResult';
import { ProcessType } from '../../Constants/Enums/Client/DashboardFilter/ProcessType';
import { PensionContributionModel } from '../../Models/Models/Processes/Apply/Pension/PensionContributionModel';
import { ServiceValidationError } from '../../Core/DataTypes/ServiceValidation/ServiceValidationError';

declare var IS_RUNNING_IN_APP_POOL;

export class PensionContributionInstructionClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public post(subAccountHierarchyId: string, headAccountHierarchyId: string, activityType: ProcessType): Promise<ValidatedResult<string>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Apply/PensionContributionInstruction/Post';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { subAccountHierarchyId: subAccountHierarchyId, headAccountHierarchyId: headAccountHierarchyId, activityType: activityType }

    return AjaxWrapper.post<ValidatedResult<string>, any>(url, data);
  }
  public get(hierarchyId: string, customerId: number, editAction: string): Promise<PensionContributionModel, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Apply/PensionContributionInstruction/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { hierarchyId: hierarchyId, customerId: customerId, editAction: editAction }

    return AjaxWrapper.get<PensionContributionModel, any>(url, data);
  }
  public put(model: PensionContributionModel, customerId: number, activityType: ProcessType): Promise<PensionContributionModel, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Apply/PensionContributionInstruction/Put';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { model: model, customerId: customerId, activityType: activityType }

    return AjaxWrapper.put<PensionContributionModel, any>(url, data);
  }
  public delete(hierarchyId: string): Promise<ServiceValidationError, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Apply/PensionContributionInstruction/Delete';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { hierarchyId: hierarchyId }

    return AjaxWrapper.delete<ServiceValidationError, any>(url, data);
  }
}

